module.exports = __webpack_public_path__ + "static/media/logo-with-text.6bf0c59f.png";